/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "api/billpayment/service.proto" (package "rd.api.billpayment", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { BillPaymentService } from "./service_pb";
import type { GetNonFullyAllocatedCreditHistoryCountRes } from "./service_pb";
import type { GetNonFullyAllocatedCreditHistoryCountReq } from "./service_pb";
import type { EmailCreditHistoryPDFRes } from "./service_pb";
import type { EmailCreditHistoryPDFReq } from "./service_pb";
import type { GetCreditHistoryPDFRes } from "./service_pb";
import type { GetCreditHistoryPDFReq } from "./service_pb";
import type { GetCreditHistoryRes } from "./service_pb";
import type { GetCreditHistoryReq } from "./service_pb";
import type { VoidFinanceChargeRes } from "./service_pb";
import type { VoidFinanceChargeReq } from "./service_pb";
import type { GetIsVoidingFinanceChargeAllowedRes } from "./service_pb";
import type { GetIsVoidingFinanceChargeAllowedReq } from "./service_pb";
import type { EmailFinanceChargePDFRes } from "./service_pb";
import type { EmailFinanceChargePDFReq } from "./service_pb";
import type { GetFinanceChargePDFRes } from "./service_pb";
import type { GetFinanceChargePDFReq } from "./service_pb";
import type { GetFinanceChargeRes } from "./service_pb";
import type { GetFinanceChargeReq } from "./service_pb";
import type { ReallocateBillPaymentRes } from "./service_pb";
import type { ReallocateBillPaymentReq } from "./service_pb";
import type { GetIsReallocatingBillPaymentAllowedRes } from "./service_pb";
import type { GetIsReallocatingBillPaymentAllowedReq } from "./service_pb";
import type { UpdateBillPaymentDateRes } from "./service_pb";
import type { UpdateBillPaymentDateReq } from "./service_pb";
import type { GetIsEditingBillPaymentDateAllowedRes } from "./service_pb";
import type { GetIsEditingBillPaymentDateAllowedReq } from "./service_pb";
import type { VoidBillPaymentRes } from "./service_pb";
import type { VoidBillPaymentReq } from "./service_pb";
import type { GetIsVoidingBillPaymentAllowedRes } from "./service_pb";
import type { GetIsVoidingBillPaymentAllowedReq } from "./service_pb";
import type { CalculateBillPaymentCardSurchargeRes } from "./service_pb";
import type { CalculateBillPaymentCardSurchargeReq } from "./service_pb";
import type { EmailBillPaymentPDFRes } from "./service_pb";
import type { EmailBillPaymentPDFReq } from "./service_pb";
import type { GetBillPaymentPDFRes } from "./service_pb";
import type { GetBillPaymentPDFReq } from "./service_pb";
import type { GetScannedBillPaymentRes } from "./service_pb";
import type { GetScannedBillPaymentReq } from "./service_pb";
import type { GetBillPaymentRes } from "./service_pb";
import type { GetBillPaymentReq } from "./service_pb";
import type { CreateWriteOffRes } from "./service_pb";
import type { CreateWriteOffReq } from "./service_pb";
import type { RefundBillPaymentRes } from "./service_pb";
import type { RefundBillPaymentReq } from "./service_pb";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { CreateBillPaymentV3Res } from "./service_pb";
import type { CreateBillPaymentV3Req } from "./service_pb";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service rd.api.billpayment.BillPaymentService
 */
export interface IBillPaymentServiceClient {
    /**
     * @generated from protobuf rpc: CreateBillPaymentV3
     */
    createBillPaymentV3(input: CreateBillPaymentV3Req, options?: RpcOptions): UnaryCall<CreateBillPaymentV3Req, CreateBillPaymentV3Res>;
    /**
     * @generated from protobuf rpc: RefundBillPayment
     */
    refundBillPayment(input: RefundBillPaymentReq, options?: RpcOptions): UnaryCall<RefundBillPaymentReq, RefundBillPaymentRes>;
    /**
     * @generated from protobuf rpc: CreateWriteOff
     */
    createWriteOff(input: CreateWriteOffReq, options?: RpcOptions): UnaryCall<CreateWriteOffReq, CreateWriteOffRes>;
    /**
     * @generated from protobuf rpc: GetBillPayment
     */
    getBillPayment(input: GetBillPaymentReq, options?: RpcOptions): UnaryCall<GetBillPaymentReq, GetBillPaymentRes>;
    /**
     * @generated from protobuf rpc: GetScannedBillPayment
     */
    getScannedBillPayment(input: GetScannedBillPaymentReq, options?: RpcOptions): UnaryCall<GetScannedBillPaymentReq, GetScannedBillPaymentRes>;
    /**
     * @generated from protobuf rpc: GetBillPaymentPDF
     */
    getBillPaymentPDF(input: GetBillPaymentPDFReq, options?: RpcOptions): UnaryCall<GetBillPaymentPDFReq, GetBillPaymentPDFRes>;
    /**
     * @generated from protobuf rpc: EmailBillPaymentPDF
     */
    emailBillPaymentPDF(input: EmailBillPaymentPDFReq, options?: RpcOptions): UnaryCall<EmailBillPaymentPDFReq, EmailBillPaymentPDFRes>;
    /**
     * @generated from protobuf rpc: CalculateBillPaymentCardSurcharge
     */
    calculateBillPaymentCardSurcharge(input: CalculateBillPaymentCardSurchargeReq, options?: RpcOptions): UnaryCall<CalculateBillPaymentCardSurchargeReq, CalculateBillPaymentCardSurchargeRes>;
    /**
     * Bill payment editing & voiding
     *
     * @generated from protobuf rpc: GetIsVoidingBillPaymentAllowed
     */
    getIsVoidingBillPaymentAllowed(input: GetIsVoidingBillPaymentAllowedReq, options?: RpcOptions): UnaryCall<GetIsVoidingBillPaymentAllowedReq, GetIsVoidingBillPaymentAllowedRes>;
    /**
     * @generated from protobuf rpc: VoidBillPayment
     */
    voidBillPayment(input: VoidBillPaymentReq, options?: RpcOptions): UnaryCall<VoidBillPaymentReq, VoidBillPaymentRes>;
    /**
     * @generated from protobuf rpc: GetIsEditingBillPaymentDateAllowed
     */
    getIsEditingBillPaymentDateAllowed(input: GetIsEditingBillPaymentDateAllowedReq, options?: RpcOptions): UnaryCall<GetIsEditingBillPaymentDateAllowedReq, GetIsEditingBillPaymentDateAllowedRes>;
    /**
     * @generated from protobuf rpc: UpdateBillPaymentDate
     */
    updateBillPaymentDate(input: UpdateBillPaymentDateReq, options?: RpcOptions): UnaryCall<UpdateBillPaymentDateReq, UpdateBillPaymentDateRes>;
    /**
     * @generated from protobuf rpc: GetIsReallocatingBillPaymentAllowed
     */
    getIsReallocatingBillPaymentAllowed(input: GetIsReallocatingBillPaymentAllowedReq, options?: RpcOptions): UnaryCall<GetIsReallocatingBillPaymentAllowedReq, GetIsReallocatingBillPaymentAllowedRes>;
    /**
     * @generated from protobuf rpc: ReallocateBillPayment
     */
    reallocateBillPayment(input: ReallocateBillPaymentReq, options?: RpcOptions): UnaryCall<ReallocateBillPaymentReq, ReallocateBillPaymentRes>;
    /**
     * Finance Charge
     *
     * @generated from protobuf rpc: GetFinanceCharge
     */
    getFinanceCharge(input: GetFinanceChargeReq, options?: RpcOptions): UnaryCall<GetFinanceChargeReq, GetFinanceChargeRes>;
    /**
     * @generated from protobuf rpc: GetFinanceChargePDF
     */
    getFinanceChargePDF(input: GetFinanceChargePDFReq, options?: RpcOptions): UnaryCall<GetFinanceChargePDFReq, GetFinanceChargePDFRes>;
    /**
     * @generated from protobuf rpc: EmailFinanceChargePDF
     */
    emailFinanceChargePDF(input: EmailFinanceChargePDFReq, options?: RpcOptions): UnaryCall<EmailFinanceChargePDFReq, EmailFinanceChargePDFRes>;
    /**
     * @generated from protobuf rpc: GetIsVoidingFinanceChargeAllowed
     */
    getIsVoidingFinanceChargeAllowed(input: GetIsVoidingFinanceChargeAllowedReq, options?: RpcOptions): UnaryCall<GetIsVoidingFinanceChargeAllowedReq, GetIsVoidingFinanceChargeAllowedRes>;
    /**
     * @generated from protobuf rpc: VoidFinanceCharge
     */
    voidFinanceCharge(input: VoidFinanceChargeReq, options?: RpcOptions): UnaryCall<VoidFinanceChargeReq, VoidFinanceChargeRes>;
    /**
     * Credit history
     *
     * @generated from protobuf rpc: GetCreditHistory
     */
    getCreditHistory(input: GetCreditHistoryReq, options?: RpcOptions): UnaryCall<GetCreditHistoryReq, GetCreditHistoryRes>;
    /**
     * @generated from protobuf rpc: GetCreditHistoryPDF
     */
    getCreditHistoryPDF(input: GetCreditHistoryPDFReq, options?: RpcOptions): UnaryCall<GetCreditHistoryPDFReq, GetCreditHistoryPDFRes>;
    /**
     * @generated from protobuf rpc: EmailCreditHistoryPDF
     */
    emailCreditHistoryPDF(input: EmailCreditHistoryPDFReq, options?: RpcOptions): UnaryCall<EmailCreditHistoryPDFReq, EmailCreditHistoryPDFRes>;
    /**
     * @generated from protobuf rpc: GetNonFullyAllocatedCreditHistoryCount
     */
    getNonFullyAllocatedCreditHistoryCount(input: GetNonFullyAllocatedCreditHistoryCountReq, options?: RpcOptions): UnaryCall<GetNonFullyAllocatedCreditHistoryCountReq, GetNonFullyAllocatedCreditHistoryCountRes>;
}
/**
 * @generated from protobuf service rd.api.billpayment.BillPaymentService
 */
export class BillPaymentServiceClient implements IBillPaymentServiceClient, ServiceInfo {
    typeName = BillPaymentService.typeName;
    methods = BillPaymentService.methods;
    options = BillPaymentService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: CreateBillPaymentV3
     */
    createBillPaymentV3(input: CreateBillPaymentV3Req, options?: RpcOptions): UnaryCall<CreateBillPaymentV3Req, CreateBillPaymentV3Res> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateBillPaymentV3Req, CreateBillPaymentV3Res>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RefundBillPayment
     */
    refundBillPayment(input: RefundBillPaymentReq, options?: RpcOptions): UnaryCall<RefundBillPaymentReq, RefundBillPaymentRes> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<RefundBillPaymentReq, RefundBillPaymentRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateWriteOff
     */
    createWriteOff(input: CreateWriteOffReq, options?: RpcOptions): UnaryCall<CreateWriteOffReq, CreateWriteOffRes> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateWriteOffReq, CreateWriteOffRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetBillPayment
     */
    getBillPayment(input: GetBillPaymentReq, options?: RpcOptions): UnaryCall<GetBillPaymentReq, GetBillPaymentRes> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetBillPaymentReq, GetBillPaymentRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetScannedBillPayment
     */
    getScannedBillPayment(input: GetScannedBillPaymentReq, options?: RpcOptions): UnaryCall<GetScannedBillPaymentReq, GetScannedBillPaymentRes> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetScannedBillPaymentReq, GetScannedBillPaymentRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetBillPaymentPDF
     */
    getBillPaymentPDF(input: GetBillPaymentPDFReq, options?: RpcOptions): UnaryCall<GetBillPaymentPDFReq, GetBillPaymentPDFRes> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetBillPaymentPDFReq, GetBillPaymentPDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: EmailBillPaymentPDF
     */
    emailBillPaymentPDF(input: EmailBillPaymentPDFReq, options?: RpcOptions): UnaryCall<EmailBillPaymentPDFReq, EmailBillPaymentPDFRes> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<EmailBillPaymentPDFReq, EmailBillPaymentPDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CalculateBillPaymentCardSurcharge
     */
    calculateBillPaymentCardSurcharge(input: CalculateBillPaymentCardSurchargeReq, options?: RpcOptions): UnaryCall<CalculateBillPaymentCardSurchargeReq, CalculateBillPaymentCardSurchargeRes> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<CalculateBillPaymentCardSurchargeReq, CalculateBillPaymentCardSurchargeRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Bill payment editing & voiding
     *
     * @generated from protobuf rpc: GetIsVoidingBillPaymentAllowed
     */
    getIsVoidingBillPaymentAllowed(input: GetIsVoidingBillPaymentAllowedReq, options?: RpcOptions): UnaryCall<GetIsVoidingBillPaymentAllowedReq, GetIsVoidingBillPaymentAllowedRes> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetIsVoidingBillPaymentAllowedReq, GetIsVoidingBillPaymentAllowedRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: VoidBillPayment
     */
    voidBillPayment(input: VoidBillPaymentReq, options?: RpcOptions): UnaryCall<VoidBillPaymentReq, VoidBillPaymentRes> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<VoidBillPaymentReq, VoidBillPaymentRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetIsEditingBillPaymentDateAllowed
     */
    getIsEditingBillPaymentDateAllowed(input: GetIsEditingBillPaymentDateAllowedReq, options?: RpcOptions): UnaryCall<GetIsEditingBillPaymentDateAllowedReq, GetIsEditingBillPaymentDateAllowedRes> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetIsEditingBillPaymentDateAllowedReq, GetIsEditingBillPaymentDateAllowedRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateBillPaymentDate
     */
    updateBillPaymentDate(input: UpdateBillPaymentDateReq, options?: RpcOptions): UnaryCall<UpdateBillPaymentDateReq, UpdateBillPaymentDateRes> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateBillPaymentDateReq, UpdateBillPaymentDateRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetIsReallocatingBillPaymentAllowed
     */
    getIsReallocatingBillPaymentAllowed(input: GetIsReallocatingBillPaymentAllowedReq, options?: RpcOptions): UnaryCall<GetIsReallocatingBillPaymentAllowedReq, GetIsReallocatingBillPaymentAllowedRes> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetIsReallocatingBillPaymentAllowedReq, GetIsReallocatingBillPaymentAllowedRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ReallocateBillPayment
     */
    reallocateBillPayment(input: ReallocateBillPaymentReq, options?: RpcOptions): UnaryCall<ReallocateBillPaymentReq, ReallocateBillPaymentRes> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<ReallocateBillPaymentReq, ReallocateBillPaymentRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Finance Charge
     *
     * @generated from protobuf rpc: GetFinanceCharge
     */
    getFinanceCharge(input: GetFinanceChargeReq, options?: RpcOptions): UnaryCall<GetFinanceChargeReq, GetFinanceChargeRes> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetFinanceChargeReq, GetFinanceChargeRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetFinanceChargePDF
     */
    getFinanceChargePDF(input: GetFinanceChargePDFReq, options?: RpcOptions): UnaryCall<GetFinanceChargePDFReq, GetFinanceChargePDFRes> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetFinanceChargePDFReq, GetFinanceChargePDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: EmailFinanceChargePDF
     */
    emailFinanceChargePDF(input: EmailFinanceChargePDFReq, options?: RpcOptions): UnaryCall<EmailFinanceChargePDFReq, EmailFinanceChargePDFRes> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<EmailFinanceChargePDFReq, EmailFinanceChargePDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetIsVoidingFinanceChargeAllowed
     */
    getIsVoidingFinanceChargeAllowed(input: GetIsVoidingFinanceChargeAllowedReq, options?: RpcOptions): UnaryCall<GetIsVoidingFinanceChargeAllowedReq, GetIsVoidingFinanceChargeAllowedRes> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetIsVoidingFinanceChargeAllowedReq, GetIsVoidingFinanceChargeAllowedRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: VoidFinanceCharge
     */
    voidFinanceCharge(input: VoidFinanceChargeReq, options?: RpcOptions): UnaryCall<VoidFinanceChargeReq, VoidFinanceChargeRes> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<VoidFinanceChargeReq, VoidFinanceChargeRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Credit history
     *
     * @generated from protobuf rpc: GetCreditHistory
     */
    getCreditHistory(input: GetCreditHistoryReq, options?: RpcOptions): UnaryCall<GetCreditHistoryReq, GetCreditHistoryRes> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetCreditHistoryReq, GetCreditHistoryRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetCreditHistoryPDF
     */
    getCreditHistoryPDF(input: GetCreditHistoryPDFReq, options?: RpcOptions): UnaryCall<GetCreditHistoryPDFReq, GetCreditHistoryPDFRes> {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetCreditHistoryPDFReq, GetCreditHistoryPDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: EmailCreditHistoryPDF
     */
    emailCreditHistoryPDF(input: EmailCreditHistoryPDFReq, options?: RpcOptions): UnaryCall<EmailCreditHistoryPDFReq, EmailCreditHistoryPDFRes> {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept<EmailCreditHistoryPDFReq, EmailCreditHistoryPDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetNonFullyAllocatedCreditHistoryCount
     */
    getNonFullyAllocatedCreditHistoryCount(input: GetNonFullyAllocatedCreditHistoryCountReq, options?: RpcOptions): UnaryCall<GetNonFullyAllocatedCreditHistoryCountReq, GetNonFullyAllocatedCreditHistoryCountRes> {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetNonFullyAllocatedCreditHistoryCountReq, GetNonFullyAllocatedCreditHistoryCountRes>("unary", this._transport, method, opt, input);
    }
}
